// API Configuration
// Uses REACT_APP_API_URL when provided, otherwise same-origin API.
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return '';
};

export const API_URL = getApiUrl();

// Where "Report a problem" in the help panel writes to. Kudos has no in-app
// feedback inbox, so it opens an email to the Kudos team's mailbox (the same
// account that sends Kudos' email); set REACT_APP_HELP_FEEDBACK_EMAIL to change it.
export const HELP_FEEDBACK_EMAIL = process.env.REACT_APP_HELP_FEEDBACK_EMAIL || 'kudos.romania@visma.com';
